export default __webpack_public_path__ + "static-front/media/SearchIcon.240245d7.svg";